const {
    concat, minBy, filter, head, find,
} = require('lodash');

const { categoryLevels } = require('./categories.constants');
const CategorySelectionList = require('./category-selection-list');

class CategoryService {
    constructor($q, $state, restangular, bootstrap, settings) {
        this.bootstrap = bootstrap;
        this._api = restangular.all('PiesCategoriesWithSpecials');
        this.categoriesPromise = null;
        this.currentCategories = new CategorySelectionList();
        this.rootCategory = { Children: [] };
        this.$state = $state;
        this.settings = settings;

        if (this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.Categories)) {
            this.categoriesPromise = $q.when(this.setupCategories(this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.Categories)));
        } else if (this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.RootCategories)) {
            this.setupCategories(this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.RootCategories));
        }

    }

    get currentCategory() {
        return this.currentCategories.current;
    }

    getAll() {
        if (!this.categoriesPromise) {
            this.categoriesPromise = this._api.one('').get().then(res => this.setupCategories(res));
        }

        return this.categoriesPromise;
    }

    setupCategories(res) {
        const categories = this.settings.category.excludeSpecials ? this.removeSpecials(res.Categories) : res.Categories;

        this.rootCategory = { Children: categories };
        this.categoriesLookup = this._buildCategoriesLookup(categories);
        return categories;
    }

    removeSpecials(categories) {
        return categories.filter(category => !category.IsSpecial);
    }

    getById(categoryNodeId) {
        return this.categoriesLookup[categoryNodeId];
    }

    _buildCategoriesLookup(categories) {
        const categoriesLookup = {};
        let remainingCategories = [...categories];

        while (remainingCategories.length) {
            const category = remainingCategories.pop();
            if (!categoriesLookup[category.NodeId]) {
                categoriesLookup[category.NodeId] = category;
            }
            if (category.Children) {
                remainingCategories = concat(remainingCategories, category.Children);
            }
        }

        return categoriesLookup;
    }

    getCategoryTree(categoryId) {
        const tree = [];
        let category = this.getById(categoryId);

        while (category) {
            tree.unshift(category);
            category = this.getById(category.ParentNodeId);
        }

        return tree;
    }

    getCategoryStateInfo(nodeId) {
        let state = 'shop.browse';
        const params = {};
        const tree = this.getCategoryTree(nodeId);

        for (let i = 0; i < tree.length; ++i) {
            state += `.${categoryLevels[i]}`;
            params[categoryLevels[i]] = tree[i].UrlFriendlyName;
        }

        return { state, params };
    }

    getCategorySref(nodeId) {
        const { state, params } = this.getCategoryStateInfo(nodeId);
        return `${state}(${JSON.stringify(params)})`;
    }

    getSpecialCategory(category) {
        return category.IsSpecial
            ? category
            : head(filter(category.Children, c => c.IsSpecial));
    }

    getBundleCategory(category) {
        return category.IsBundle
            ? category
            : head(filter(category.Children, c => c.IsBundle));
    }

    getFirstSpecialCategory(departmentCategory) {
        if (!departmentCategory.Children) return undefined;
        // get the first category in order in the department children
        const firstCategoryInDepartment = minBy(
            filter(departmentCategory.Children, category => !category.NodeId.match('_SPECIALS')),
            category => category.DisplayOrder,
        );
        // get the first special category in firstCategoryInDepartment.
        if (firstCategoryInDepartment) {
            return this.getSpecialCategory(firstCategoryInDepartment);
        }

        return undefined;
    }

    _findNodeByNodeId(categoryTree, nodeId) {
        return find(categoryTree, categoryNode => categoryNode.NodeId === nodeId);
    }

    _getCategoryPathToRoot(categoryTree, baseNodeId) {
        const links = [];
        let currentNode = find(categoryTree, categoryNode => categoryNode.NodeId === baseNodeId);
        links.unshift({ text: currentNode.Description });
        while (currentNode.ParentNodeId !== null) {
            const parentNode = this._findNodeByNodeId(categoryTree, currentNode.ParentNodeId);
            const categoryState = this.getCategoryStateInfo(parentNode.NodeId);

            links.unshift({ text: parentNode.Description, url: this.$state.href(categoryState.state, categoryState.params, { inherit: false }) });
            currentNode = parentNode;
        }
        links.unshift({ text: 'Home', url: '/' });
        return links;
    }

    getCategoryPathToToRootByNodeId(nodeId) {
        const categoryTree = this.getCategoryTree(nodeId);
        return this._getCategoryPathToRoot(categoryTree, nodeId);
    }
}

CategoryService.$inject = ['$q', '$state', 'Restangular', 'BootstrapService', 'Settings'];

module.exports = CategoryService;



// WEBPACK FOOTER //
// ./src/shop/categories/categories.service.js